export const getFileExtension = (fileName: string) => fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();